import { useEffect, useState } from "react";

const API = process.env.REACT_APP_API_URL || "";

/**
 * 견적 메뉴를 보여줄 지역인지 서버에 물어본다 (설계 4 "한국 IP 에서만 노출").
 *
 * 판정은 서버가 한다 — 브라우저 언어·시간대는 손님이 바꿀 수 있어 기준이 못 된다.
 * 아직 못 정했을 때(null)는 화면을 흔들지 않도록 아무것도 그리지 않는 쪽이 좋다.
 */
export default function useQuoteRegion() {
  const [allowed, setAllowed] = useState(null); // null = 확인 중

  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/quote-jobs/region`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive) return;
        // 서버에 못 물어봤으면 막지 않는다 — 한국 손님을 잘못 막는 쪽이 더 나쁘다
        setAllowed(d ? Boolean(d.allowed) : true);
      })
      .catch(() => { if (alive) setAllowed(true); });
    return () => { alive = false; };
  }, []);

  return allowed;
}

/**
 * 업로드 상한은 쿠키스토리 전송 제한, 최소 주문금액은 print 공통 설정이다.
 * 못 받아오면 아래 기본값 — 그래도 서버가 다시 거른다.
 */
export function useQuoteLimits() {
  const [limits, setLimits] = useState({
    maxBytes: 52428800,        // 파일 1개 50MB
    maxTotalBytes: 209715200,  // 합계 200MB
    maxFiles: 100,
    minOrderPrice: null,       // print 조회 전에는 옛 금액을 보여주지 않는다
    shippingBase: 3300,        // 기본 배송비 (어드민 배송비 설정을 그대로 받아 쓴다)
  });

  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/quote-jobs/region`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive && d?.limits) setLimits((p) => ({ ...p, ...d.limits }));
      })
      .catch(() => { /* 기본값 그대로 */ });
    return () => { alive = false; };
  }, []);

  return limits;
}
